import { Injectable, NgZone } from '@angular/core';
import { Platform } from '@ionic/angular';
// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service'; 

// https://ionicframework.com/docs/native/network
import { Network } from '@ionic-native/network/ngx';

import { RuntimeService } from '../runtime/runtime.service';
import { ApiService } from '../api/api.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from '../global/global.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { Observable } from 'rxjs/internal/Observable';
import { ConnectivityData } from '../global/structure';
import { fromEvent } from 'rxjs';
//import { Subscription } from 'rxjs';
//import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityService 
{
    private pageName:string = "[SINGLETON]";
    private connectionObserver: any;
    public connection: any;
  
    connected: Subscription;
    disconnected: Subscription;
    private connectivityData:ConnectivityData = new ConnectivityData();
  
    private consoleLog:boolean = false;
  
    constructor(public events: Events
      , private network: Network
      , private runtime: RuntimeService
      , private apiProvider: ApiService
      , public zone: NgZone 
      , public translate: TranslateService
      , public globalProvider: GlobalService 
      , private platform: Platform
    ) 
    {
      this.consoleLog = this.globalProvider.consoleLog_connectivity;
      if (this.consoleLog) console.log('Connectivity.ctor - LifeCycle');
      //this.InitializeProvider();
  
      this.platform.ready().then(() => 
      {
        this.SetupListener();
      });
    }

    SetupListener()
    {
      if (this.consoleLog) console.log("Connectivity.SetupListener" + " - Page:" + this.pageName);

      if ('onLine' in navigator) 
      {
        this.connectivityData.IsOnline = navigator.onLine;
      }

      // check if we are on device or if its a browser:
      if (this.runtime.IsBrowser()) 
      {
        // ------------------  BROWSER  -------------------
        if (this.consoleLog) console.log("Connectivity.SetupListener: BROWSER" + " - Page:" + this.pageName);
        this.connectivityData.IsBrowser = true;

        // BROWSER: watch network for a disconnect
        fromEvent(window, "offline").subscribe(() => 
        {
          this.publishStatus(false);
        });

        // BROWSER: watch network for a connection
        fromEvent(window, "online").subscribe(() => 
        {
          this.publishStatus(true);
          this.CallTestServerResponseTime();  // check the call time now that we are back online...
        });

        if (this.consoleLog) console.log("Connectivity: LISTENING (BROWSER)"  + " - Page:" + this.pageName);
      }
      else
      {
        // ------------------  DEVICE  -------------------
        if (this.consoleLog) console.log("Connectivity.SetupNetworkListener: NATIVE" + " - Page:" + this.pageName);
        this.connectivityData.IsBrowser = false;

        // DEVICE: watch network for a disconnect
        this.network.onDisconnect().subscribe(() => 
        {
          this.publishStatus(false);
        });
        
        // DEVICE: watch network for a connection
        this.network.onConnect().subscribe(() => 
        {
          this.publishStatus(true);

          if (this.network.type === "wifi") 
          {
            //console.log("app.NetworkStatus: Online Network", this.network);
            // We just got a connection but we need to wait briefly before we determine
            // the connection type. Might need to wait, prior to doing any api requests as well.
            setTimeout(() => 
            {
              console.log("Connectivity: NETWORK TYPE: " + this.network.type + " - Page:" + this.pageName, this.network);
              this.publishNetworkType(this.network.type);
            }, 3000);
          }

          this.CallTestServerResponseTime();
        });

        if (this.consoleLog) console.log("connectivity: LISTENING (NATIVE)" + " - Page:" + this.pageName);
      }  

      if (!this.connectivityData.IsOnline) 
      {
        if (this.consoleLog) console.log("connectivity: ONLINE" + " - Page:" + this.pageName);
      }
    }


    // Send that information to all the subscribers
    public publishStatus(isOnline: boolean) 
    {
      let runtimeName = (this.runtime.GetRuntimeName());

      console.log("Connectivity.publishStatus-" + runtimeName + " from:" + this.connectivityData.IsOnline + " to:" + isOnline + " - Page:" + this.pageName);
      this.connectivityData.IsOnline = isOnline;
      
      //this.connectivityData.IsOnline = isOnline;
      //if (this.connectionObserver) this.connectionObserver.next(isOnline);

      console.log("Connectivity.publishStatus-" + runtimeName, this.connectivityData);
      this.events.publish('connectivityData', { ConnectivityData: this.connectivityData});
    }

    // Send any update to the network type
    public publishNetworkType(networkType:string) 
    {
      let runtimeName = (this.runtime.GetRuntimeName());

      console.log("Connectivity.publishNetworkType-" + runtimeName + " from:" + this.connectivityData.NetworkType + " to:" + networkType + " - Page:" + this.pageName);
      this.connectivityData.NetworkType = networkType;
      
      console.log("Connectivity.publishNetworkType-" + runtimeName + ": " + networkType, this.connectivityData);
      this.events.publish('connectivityData', { ConnectivityData: this.connectivityData});
    }


    // use this to initialize each screen's connectivity status
    public IsOnline():boolean
    {
      return this.connectivityData.IsOnline;
    }

    public GetConnectivityData(): ConnectivityData
    {
      return this.connectivityData;
    }

    CallTestServerResponseTime()
    {
      if (this.consoleLog) console.log("Connectivity.CallTestServerResponseTime - Page:" + this.pageName);
      this.apiProvider.TestServerResponseTime()
      .then(data => { 
        this.publishStatus(true);
        if (this.consoleLog) console.log("Connectivity: ONLINE (TestServerResponseTime) - Page:" + this.pageName); //, data);
       }
      , errorMessage => {
        //this.connectionHasChanged(false);
        console.warn("Connectivity: OFFLINE (TestServerResponseTime) - Page:" + this.pageName, errorMessage);
      });
    }

    // ******************************************************************************
    // ******************************************************************************
    // ******************************************************************************
    // *********************  OLD OLD OLD OLD OLD OLD OLD OLD ***********************
    // *********************  OLD OLD OLD OLD OLD OLD OLD OLD ***********************
    // *********************  OLD OLD OLD OLD OLD OLD OLD OLD ***********************
    // *********************  OLD OLD OLD OLD OLD OLD OLD OLD ***********************
    // ******************************************************************************
    // ******************************************************************************
    // ******************************************************************************



    /*
    InitializeProvider_OLD()
    {
      this.connectivityData.IsBrowser = this.runtime.IsBrowser();
      this.SetupObservable();
    }
  
    SetupObservable()
    {
      if (this.consoleLog) console.log("Connectivity.SetupObservable");
      this.connectionObserver = null;
      this.connection = Observable.create(observer => {
          this.connectionObserver = observer;
          this.connectionObserver.next(this.connectivityData.IsOnline);
      });
    }
  
    // Send that information to all the subscribers
    public connectionHasChanged(isOnline: boolean) {
      console.log("Connectivity.connectionHasChanged from:" + this.connectivityData.IsOnline + " to:" + isOnline);
      this.connectivityData.IsOnline = isOnline;
      if (this.connectionObserver) this.connectionObserver.next(isOnline);

      console.log("Connectivity.connectionHasChanged - publish event", this.connectivityData);
      this.events.publish('connectivityData', { ConnectivityData: this.connectivityData});
    }
  
  
    // Call this from the app when ionic/cordova is ready
    addListeners(pageName:string)
    {
      console.log("Connectivity.addListeners - Page:" + pageName);
      this.pageName = pageName; // should only ever be the app.component
      this.CallTestServerResponseTime();  // to help setup initial connectivity state
      this.SetListeners(true);
    }
  
    SetListeners(isStartSubscribe:boolean)
    {
      if (this.consoleLog) console.log('Connectivity.SetListeners ' + isStartSubscribe + ' - Page:' + this.pageName);
      this.connectivityData.NetworkType = this.network.type;
      //console.log('app.SetListenersNetwork ' + this.network.type, this.network);
  
      if (isStartSubscribe)
      {
        this.disconnected = this.network.onDisconnect().subscribe(data => {
          this.zone.run(() => {
            this.connectionHasChanged(false);
          });
          console.log("Connectivity: OFFLINE - Page:" + this.pageName, data);
          //console.log("app.NetworkStatus: Offline Network", this.network);
        }, error => console.error(error));
  
        this.connected = this.network.onConnect().subscribe(data => {
          this.zone.run(() => {
            this.connectionHasChanged(true);
          });
          console.log("Connectivity: ONLINE - Page:" + this.pageName, data);
          //console.log("app.NetworkStatus: Online Network", this.network);
          // We just got a connection but we need to wait briefly
          // before we determine the connection type. Might need to wait.
          // prior to doing any api requests as well.
          setTimeout(() => 
          {
            console.log("Connectivity: NETWORK TYPE: " + this.network.type + " - Page:" + this.pageName, this.network);
            this.connectivityData.NetworkType = this.network.type;
          }, 3000);

        }, error => console.error(error));
      }
      else
      {
        if (this.connected) this.connected.unsubscribe();
        if (this.disconnected) this.disconnected.unsubscribe();
      }
    }
    */
  
  }
